import { Component, EventEmitter, Inject, Input, OnChanges, Optional, Output, SimpleChanges } from '@angular/core';
import { GridModalComponent } from '@app/core/components/grid/grid.decorators';
import { RememberService } from '@app/core/services/remember.service';
import { StateDialogContext, TT_STATE_DIALOG } from '@app/modal/state-modal/state-modal.component';
import { GetSelectProjectParams, ProjectItem, ProjectService, SelectProjectGet } from '@app/services/project.service';

@GridModalComponent('selectproject')
@Component({
    selector: 'tt-select-project',
    templateUrl: './select-project.component.html',
    styleUrls: ['./select-project.component.css'],
})
export class SelectProjectComponent implements OnChanges {
    @Input()
    public params?: GetSelectProjectParams;

    public get?: SelectProjectGet;

    public projects: ProjectItem[] = [];

    @Output()
    public submit = new EventEmitter<ProjectItem>();

    constructor(
        private project: ProjectService,
        private remember: RememberService,
        @Optional() @Inject(TT_STATE_DIALOG) context: StateDialogContext,
    ) {
        this.initFromDialog(context);
    }

    public async onProjectSelected(event: { item: ProjectItem; event: MouseEvent }) {
        await this.remember.remember('w_selectproject.project_keyno', event.item.item_id);
        this.submit.emit(event.item);
    }

    private async loadGet() {
        if (!!this.params) {
            this.get = await this.project.getSelectProject(this.params);
        }
    }

    public async loadProjects() {
        if (!!this.get) {
            this.projects = await this.project.getProjects({ ...this.get, searchtext: '' });
        }
    }

    private async init() {
        await this.loadGet();
        this.loadProjects();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['params']) {
            this.init();
        }
    }

    private async initFromDialog(context?: StateDialogContext) {
        if (!!context) {
            context.setSize({ width: 'min(98vw, 50rem)', height: 'min(98vh, 95rem)' });
            context.setHeading('p2_m_selectproject', true);
            this.params = context.params as unknown as GetSelectProjectParams;
            await this.init();
            this.submit.subscribe({ next: (value: ProjectItem) => context.close(value) });
        }
    }
}
